import { render, staticRenderFns } from "./Shmedicineslist.vue?vue&type=template&id=a640c1d8&scoped=true&"
import script from "./Shmedicineslist.vue?vue&type=script&lang=js&"
export * from "./Shmedicineslist.vue?vue&type=script&lang=js&"
import style0 from "./Shmedicineslist.vue?vue&type=style&index=0&id=a640c1d8&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a640c1d8",
  null
  
)

export default component.exports